import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import CreateChannelContainer from 'features/inventory/channel/containers/CreateChannelContainer/CreateChannelContainer';
import { History } from 'history';
import {
  PublisherLegacy,
  usePublisherMinimalLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';

export interface ICreateChannelPageProps {
  history: History;
  match: {
    params: {
      publisherId: string;
    };
  };
}

const CreateChannelPage = ({ history, match }: ICreateChannelPageProps) => {
  const { loading, error, data } = usePublisherMinimalLegacyQuery({
    variables: {
      id: match.params.publisherId,
    },
  });

  if (!loading && (error || !(data && data.publisherLegacy)))
    return <Redirecting history={history} />;

  return (
    <main data-testid="createChannelPage">
      <Container>
        <h1 className="sr-only">Create Channel</h1>
        {loading ? (
          <Loader />
        ) : (
          <CreateChannelContainer
            history={history}
            match={match}
            publisher={data?.publisherLegacy as PublisherLegacy}
          />
        )}
      </Container>
    </main>
  );
};
export default CreateChannelPage;
